import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ds-card',
  templateUrl: './ds-card.component.html',
  styleUrls: ['./ds-card.component.scss']
})
export class DsCardComponent {
  private _interactive = false;

  @Input()
  set interactive(value: boolean) {
    const raw = value as unknown;
    this._interactive = raw === '' || raw === true || raw === 'true';
  }
  get interactive(): boolean {
    return this._interactive;
  }

  @Output() cardClick = new EventEmitter<void>();

  @HostBinding('class.ds-card') readonly hostClass = true;

  @HostBinding('class.ds-card--interactive')
  get interactiveClass(): boolean {
    return this._interactive;
  }

  @HostListener('click')
  onHostClick(): void {
    if (this._interactive) {
      this.cardClick.emit();
    }
  }
}
